import { getClient } from "services/utils/ServiceClientRegistry";

export async function getSessionMessages(sessionId: string) {
  return await getClient("chatbotService").fetchSessionMessages(sessionId);
}

export async function getSessions({
  limit,
  lastKey
}: {
  limit?: number;
  lastKey?: string;
} = {}) {
  return getClient("chatbotService").fetchSessions({ limit, lastKey });
}

export async function renameSession({
  sessionId,
  title
}: {
  sessionId: string;
  title: string;
}) {
  return getClient("chatbotService").renameSession({ sessionId, title });
}

export async function deleteSession(sessionId: string) {
  return getClient("chatbotService").deleteSession(sessionId);
}
